import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-search",
  "use": "icon-cl-search-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cl-search\"><circle cx=\"6.5\" cy=\"6.5\" r=\"3.75\" stroke=\"#555\" stroke-width=\"1.5\" /><rect x=\"8.367\" y=\"9.459\" width=\"1.545\" height=\"6.623\" rx=\".773\" transform=\"rotate(-45 8.367 9.46)\" fill=\"#555\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol